<template>
  <div v-if="!loading">
    <Header
      :subtitle="`${data.status.internalTextStatus} (they see ${data.status.textStatus})`"
      :title="`${data.firstName} ${data.lastName}`"
    >

      <Button v-if="data.status.confirmed" @click="checkInUser" :icon="{ left: `map-pin` }">Check In</Button>
      <router-link :to="`/review/${this.$route.params.id}`">
        <Button :icon="{ left: `gavel` }">Review</Button>
      </router-link>
      <DeleteApplicant v-if="adminUser.roles.admin" />
    </Header>
    <div :class="[$style.items, $style.items3]">
      <PersonalInfo :data="data" />
      <EducationInfo :data="data" />
      <ExperienceInfo :data="data" />
    </div>
    <div :class="[$style.items]">
      <template
        v-for="{ name, question } in Object.keys(longResponseQuestions).map(
          (n) => ({ name: n, question: longResponseQuestions[n] }),
        )"
      >
        <LongResponse
          :data="data.hackerApplication[name]"
          :title="question"
        />
      </template>
    </div>

    <div :class="[$style.items, $style.items2]">
      <LocationInfo :data="data" />
      <AdminInfo :data="data" />
    </div>
    <div :class="[$style.items]">
      <SocialLinkInfo :data="data" />
    </div>
    <div :class="[$style.items]">
      <AdminRaw v-if="adminUser.roles.admin" :user="data" :updateUser="updateUser" />
    </div>
  </div>
</template>

<script>
  import Button from '@hackthe6ix/vue-ui/Button';
  import TextComponent from '@hackthe6ix/vue-ui/Text';
  import swal from 'sweetalert';
  import 'vue-awesome/icons/gavel';
  import 'vue-awesome/icons/map-pin';
  import Header from '../../../../containers/Header/index';
  import { getObject } from '../../../../utils/api';
  import { getUser } from '../../../../utils/UserController';
  import DeleteApplicant from '../actions/DeleteApplicant/index';
  import EditApplicant from '../actions/EditApplicant/index';
  import AdminInfo from '../sections/AdminInfo';
  import AdminRaw from '../sections/AdminRaw';
  import EducationInfo from '../sections/EducationInfo';
  import ExperienceInfo from '../sections/ExperienceInfo';
  import LocationInfo from '../sections/LocationInfo';
  import LongResponse from '../sections/LongResponse';
  import PersonalInfo from '../sections/PersonalInfo';
  import SocialLinkInfo from "../sections/SocialLinkInfo";
  import {applicationQuestions} from "@/utils/const";
  import {processCheckInUser} from "@/utils/checkInShared";

  export default {
  name: `ApplicantDetails`,
  components: {
    SocialLinkInfo,
    DeleteApplicant,
    ExperienceInfo,
    EditApplicant,
    TextComponent,
    EducationInfo,
    PersonalInfo,
    LocationInfo,
    LongResponse,
    AdminInfo,
    AdminRaw,
    Button,
    Header,
  },
  data() {
    return {
      loading: true,
      data: {},
      adminUser: {},
      longResponseQuestions: applicationQuestions,
    };
  },
  props: {
    id: String,
  },
  methods: {
    updateUser(user) {
      this.data = user;
    },
    checkInUser() {
      processCheckInUser(this.data, "User");
    }
  },
  beforeMount() {
    (async () => {
      this.adminUser = await getUser();

      const response = await getObject('user', {
        filter: {
          _id: this.id,
        },
      });

      if (response.success && response.data[0]) {
        this.data = response.data[0];
        this.loading = false;
      } else {
        swal('Error', 'Unable to get user', 'error');
      }
    })();
  },
};
</script>

<style src="../Applicant.module.scss" lang="scss" module />
